import React from 'react';
import Axios from 'axios';

const VIEW_BUTTON_RENAME_STARTDATE = false;
const VIEW_BUTTON_RENAME_ELO = false;
const VIEW_BUTTON_TEAMMATCH = false;
const VIEW_BUTTON_TMRROUNDSLOST = false;
const VIEW_BUTTON_GRADDLEAGUETYPES = false;
const VIEW_BUTTON_ADDTVINRESULTS = false;
const VIEW_BUTTON_USERPLAYERID = false;
const VIEW_BUTTON_SUBSEASON_TYPE = false;
const VIEW_BUTTON_DMSEVOL01_SCORESHEETS = false;
const VIEW_BUTTON_PMROPPID = false;
const VIEW_BUTTON_SSHDCPCORR = false;
const VIEW_BUTTON_PLAYERRATINGTYPES = true;
const VIEW_BUTTON_PLAYERSLASTGAMEDATE = true;		// TO DO EVENTUALLY
const VIEW_BUTTON_QVNEATEMPRATINGS = true;
const VIEW_BUTTON_MONTQVNEACREATEPROGRAMS2019 = false;
const VIEW_BUTTON_MONTQVNEACREATEPROGRAMS2020 = false;
const VIEW_BUTTON_MONTQVNEACREATESUMMARY = true;

class devScripts extends React.Component {

  constructor(props) {
		super(props);
		//this.dummyfunction = this.dummyfunction.bind(this);
	}

	render() {

		return (
			<div>
				<h3>Dev Scripts</h3>
				Les scripts sont disponibles sur des boutons que l'on doit activer dans les constants du code                
				<br/><br/>

				{this.viewButtonRenameSubseasonStartDate()}
				{this.viewButtonRenameElo()}
				{this.viewButtonTeamMatchsPMR()}
				{this.viewButtonTeamMatchsTMR()}
				{this.viewButtonTeamMatchsGR()}
				{this.viewButtonProcessTMRroundsLost()}
				{this.viewButtonProcessGRaddLeagueTypes()}
				{this.viewButtonAddTVinResults()}
				{this.viewButtonProcessUserPlayerId()}
				{this.viewButtonSubseasonType()}
				{this.viewButtonDMSEvol01()}
				{this.viewButtonPMRoppid()}
				{this.viewButtonScoresheetsHandicapCorrections()}
				{this.viewButtonPlayerRatingTypes()}
				{this.viewButtonPlayersLastGameDates()}
				{this.viewButtonQvneaTempRatings()}
				{this.viewButtonMontQvneaCreatePrograms2019()}
				{this.viewButtonMontQvneaCreatePrograms2020()}
				{this.viewButtonMontQvneaCreateSummary()}
			</div>
		);
	}

	// *****************************************************************************************************************
	viewButtonRenameSubseasonStartDate() {
		if (VIEW_BUTTON_RENAME_STARTDATE) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_RenameSubseasonStartDate}>
						dev script: renaming StartDate to startDate
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_RenameSubseasonStartDate(e) {
		Axios.post('/api/devScripts/script_rename_startdate', {});
	}

	// *****************************************************************************************************************
	viewButtonRenameElo() {
		if (VIEW_BUTTON_RENAME_ELO) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_RenameElo}>
						dev script: renaming elo to ero
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_RenameElo(e) {
		Axios.post('/api/devScripts/script_rename_elo', {});
	}

	// *****************************************************************************************************************
	viewButtonTeamMatchsPMR() {
		if (VIEW_BUTTON_TEAMMATCH) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_teamMatchs_PMR}>
						dev script: Team Matchs support PlayerMatchResults 
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_teamMatchs_PMR(e) {
		Axios.post('/api/devScripts/script_teamMatchs_pmr', {});
	}

	// *****************************************************************************************************************
	viewButtonTeamMatchsTMR() {
		if (VIEW_BUTTON_TEAMMATCH) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_teamMatchs_TMR}>
						dev script: Team Matchs support TeamMatchResults 
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_teamMatchs_TMR(e) {
		Axios.post('/api/devScripts/script_teamMatchs_tmr', {});
	}

	// *****************************************************************************************************************
	viewButtonTeamMatchsGR() {
		if (VIEW_BUTTON_TEAMMATCH) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_teamMatchs_GR}>
						dev script: Team Matchs support GameResults 
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_teamMatchs_GR(e) {
		Axios.post('/api/devScripts/script_teamMatchs_gr', {});
	}

	// *****************************************************************************************************************
	viewButtonProcessTMRroundsLost() {
		if (VIEW_BUTTON_TMRROUNDSLOST) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_tmrRoundsLost}>
						dev script: Team Matchs Results - Rounds Lost
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_tmrRoundsLost(e) {
		Axios.post('/api/devScripts/script_tmrRoundsLost', {});
	}

	// *****************************************************************************************************************
	viewButtonProcessGRaddLeagueTypes() {
		if (VIEW_BUTTON_GRADDLEAGUETYPES) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_grAddLeagueTypes}>
						dev script: Game Results - Add League Types
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_grAddLeagueTypes(e) {
		Axios.post('/api/devScripts/script_graddleaguetype', {});
	}

	// *****************************************************************************************************************
	viewButtonAddTVinResults() {
		if (VIEW_BUTTON_ADDTVINRESULTS) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_addTVinResults}>
						dev script: Add TV in Results
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_addTVinResults(e) {
		Axios.post('/api/devScripts/script_addTvInResults', {});
	}

	// *****************************************************************************************************************
	viewButtonProcessUserPlayerId() {
		if (VIEW_BUTTON_USERPLAYERID) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_userPlayerId}>
						dev script: Convert PlayerIds
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_userPlayerId(e) {
		Axios.post('/api/devScripts/script_usersplayersid', {});
	}

	// *****************************************************************************************************************
	viewButtonSubseasonType() {
		if (VIEW_BUTTON_SUBSEASON_TYPE) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_subseasonType}>
						dev script: Add Subseasons Type
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_subseasonType(e) {
		Axios.post('/api/devScripts/script_subseasonType', {});
	}

	// *****************************************************************************************************************
	viewButtonDMSEvol01() {
		if (VIEW_BUTTON_DMSEVOL01_SCORESHEETS) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_dmsevol01}>
						dev script: Scoresheet to DMS Evol01
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_dmsevol01(e) {
		Axios.post('/api/devScripts/script_dmsevol01', {});
	}

	// *****************************************************************************************************************
	viewButtonPMRoppid() {
		if (VIEW_BUTTON_PMROPPID) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_pmroppid}>
						dev script: PlayerMatchResults Opponent Id
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_pmroppid(e) {
		Axios.post('/api/devScripts/script_pmroppid', {})
		.then(function(response) {
			console.log('SCRIPT DONE!');
		})
		.catch(function(error) {
			console.log(error);
		});;
	}

	// *****************************************************************************************************************
	viewButtonScoresheetsHandicapCorrections() {
		if (VIEW_BUTTON_SSHDCPCORR) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_ssHdcpCorr_BeauportAH2016}>
						dev script: Scoresheets Handicap Corrections - Beauport AH2016
					</button>
					<br/>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_ssHdcpCorr_MultiAH2016}>
						dev script: Scoresheets Handicap Corrections - Budweiser / Compétition AH2016
					</button>
					<br/>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_ssHdcpCorr_strings}>
						dev script: Scoresheets Handicap Corrections - Strings
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_ssHdcpCorr_BeauportAH2016(e) {
		Axios.post('/api/devScripts/script_ssHdcpCorr_BeauportAH2016', {})
		.then(function(response) {
			console.log('SCRIPT DONE: runDevScript_ssHdcpCorr_BeauportAH2016');
		})
		.catch(function(error) {
			console.log(error);
		});;
	}

	runDevScript_ssHdcpCorr_MultiAH2016(e) {
		Axios.post('/api/devScripts/script_ssHdcpCorr_MultiAH2016', {})
		.then(function(response) {
			console.log('SCRIPT DONE: runDevScript_ssHdcpCorr_MultiAH2016');
		})
		.catch(function(error) {
			console.log(error);
		});;
	}

	runDevScript_ssHdcpCorr_strings(e) {
		Axios.post('/api/devScripts/script_ssHdcpCorr_strings', {})
		.then(function(response) {
			console.log('SCRIPT DONE: runDevScript_ssHdcpCorr_strings');
		})
		.catch(function(error) {
			console.log(error);
		});;
	}


	// *****************************************************************************************************************
	viewButtonPlayerRatingTypes() {
		if (VIEW_BUTTON_PLAYERRATINGTYPES) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_playerRatingTypes}>
						dev script: Player Last Ratings
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_playerRatingTypes(e) {
		Axios.post('/api/devScripts/script_playerRatingTypes', {})
		.then(function(response) {
			console.log('SCRIPT DONE: runDevScript_playerRatingTypes');
		})
		.catch(function(error) {
			console.log(error);
		});;
	}

	// *****************************************************************************************************************
	viewButtonPlayersLastGameDates() {
		if (VIEW_BUTTON_PLAYERSLASTGAMEDATE) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_setPlayersLastGameDates}>
						dev script: set Players Last Game Date in LastRatings
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_setPlayersLastGameDates(e) {
		Axios.post('/api/devScripts/schedulerTask_setPlayersLastGameDates', {})
		.then(function(response) {
			console.log('SCRIPT DONE: schedulerTask_setPlayersLastGameDates');
		})
		.catch(function(error) {
			console.log(error);
		});;
	}

	// *****************************************************************************************************************
	viewButtonQvneaTempRatings() {
		if (VIEW_BUTTON_QVNEATEMPRATINGS) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_qvneaTempRatings}>
						dev script: QVNEA set Temp ratings
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_qvneaTempRatings(e) {
		Axios.post('/api/devScripts/schedulerTask_setQvneaPlayersRatingTemp', {})
		.then(function(response) {
			console.log('SCRIPT DONE: schedulerTask_setQvneaPlayersRatingTemp');
		})
		.catch(function(error) {
			console.log(error);
		});;
	}

	// *****************************************************************************************************************
	viewButtonMontQvneaCreatePrograms2019() {
		if (VIEW_BUTTON_MONTQVNEACREATEPROGRAMS2019) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_montQvneaCreatePrograms.bind(this, "2019")}>
						dev script: Mont QVNEA - Create programs 2019
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	// *****************************************************************************************************************
	viewButtonMontQvneaCreatePrograms2020() {
		if (VIEW_BUTTON_MONTQVNEACREATEPROGRAMS2020) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_montQvneaCreatePrograms.bind(this, "2020")}>
						dev script: Mont QVNEA - Create programs 2020
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_montQvneaCreatePrograms(year, e) {
		Axios.post('/api/devScripts/db_script_createMontQvneaPrograms', {
			year: year
		})
		.then(function(response) {
			console.log('SCRIPT DONE: db_script_createMontQvneaPrograms');
		})
		.catch(function(error) {
			console.log(error);
		});;
	}

	// *****************************************************************************************************************
	viewButtonMontQvneaCreateSummary() {
		if (VIEW_BUTTON_MONTQVNEACREATESUMMARY) {
			return (
				<div>
					<button type="button" id='gobutton' className="btn btn-primary" onClick={this.runDevScript_montQvneaCreateSummary}>
						dev script: Mont QVNEA - Create summary
					</button>
					<br/><br/>
				</div>
			);
		}
	}

	runDevScript_montQvneaCreateSummary(e) {
		Axios.post('/api/devScripts/db_script_createMontQvneaSummary', {})
		.then(function(response) {
			console.log('SCRIPT DONE: db_script_createMontQvneaSummary');
		})
		.catch(function(error) {
			console.log(error);
		});;
	}

}

export default devScripts;